{
  "welcome": "Bienvenue sur Harmonia",
  "landing": {
    "nav": {
      "brand": "Harmonia",
      "install": "Installer",
      "cta": "Rejoindre"
    },
    "installHints": {
      "ios": {
        "title": "Installer Harmonia",
        "step1": "1. Appuyez sur l'icône Partager de Safari",
        "step2": "2. Choisissez « Sur l'écran d'accueil »",
        "step3": "3. Confirmez avec « Ajouter »",
        "close": "Compris"
      },
      "firefox": {
        "title": "Installer Harmonia",
        "step1": "1. Ouvrez le menu (≡) de Firefox",
        "step2": "2. Choisissez « Installer » ou « Ajouter à l'écran d'accueil »",
        "step3": "3. Confirmez l'installation",
        "close": "Compris"
      },
      "generic": {
        "title": "Installer Harmonia",
        "step1": "1. Ouvrez le menu de votre navigateur",
        "step2": "2. Cherchez « Installer l'application » ou « Ajouter à l'écran d'accueil »",
        "step3": "3. Confirmez l'installation",
        "close": "Compris"
      }
    },
    "hero": {
      "pill": "Centre des Talents",
      "titleLine1": "Révélez",
      "titleLine2": "votre",
      "titleHighlight": "talent",
      "titleLine3": "au monde",
      "sub": "La plateforme conçue pour inspirer, rassembler et propulser les créateurs, gamers et innovateurs.",
      "statDisciplines": "Disciplines",
      "statConcours": "Concours",
      "statTrophees": "Trophées Live",
      "badgeTrophees": "Trophées",
      "badgeLive": "Live",
      "badgeCommunaute": "Communauté",
      "ctaMain": "Démarrer l'aventure",
      "ctaInstall": "Installer l'app",
      "ctaSecondary": "Explorer l'univers"
    },
    "market": {
  "chip": "SOLUTION PRO",
  "titleLine1": "Votre boutique,",
  "titleLine2": "votre site, votre monde",
  "sub": "Commerçants, artisans, entrepreneurs : créez votre boutique sur Harmonia et obtenez un véritable site internet, personnalisable et accessible partout dans le monde — sur la plateforme comme en dehors.",
  "feature1Title": "Site complet & personnalisable",
  "feature1Desc": "Chaque boutique devient un site web à part entière, à votre image : mise en page, présentation, identité visuelle.",
  "feature2Title": "Un lien URL pour votre boutique",
  "feature2Desc": "Partagez votre boutique n'importe où grâce à un lien public fonctionnel, sans que vos clients aient besoin d'un compte.",
  "feature3Title": "Un lien URL par produit",
  "feature3Desc": "Chaque produit dispose de sa propre page complète et de son propre lien, prêt à être publié sur tous vos réseaux.",
  "feature4Title": "Présent partout, vendez partout",
  "feature4Desc": "Publiez, présentez et échangez avec vos clients sur toutes les plateformes, où qu'ils se trouvent dans le monde.",
  "statBoutiques": "Boutiques actives",
  "statProduits": "Produits publiés",
  "statMonde": "Accessible mondialement",
  "cta": "Créer ma boutique"
},
    "vision": {
      "chip": "NOTRE VISION",
      "titleLine1": "Une harmonie",
      "titleLine2": "planétaire",
      "sub": "Nous croyons que le talent n'a pas de frontières. Harmonia est l'espace où vos idées prennent vie, soutenues par une énergie collective sans précédent.",
      "card1Title": "Créativité libre",
      "card1Desc": "Un espace bienveillant conçu pour laisser libre cours à votre imagination, sans barrières.",
      "card2Title": "Connexions fortes",
      "card2Desc": "Rencontrez des esprits passionnés, collaborez sur des projets inédits et grandissez ensemble.",
      "card3Title": "Évolution constante",
      "card3Desc": "Entourez-vous d'une dynamique positive qui pousse chacun à se dépasser au quotidien."
    },
    "disciplines": {
      "chip": "NOS DISCIPLINES",
      "titleLine1": "Choisissez",
      "titleLine2": "votre scène",
      "sub": "Des concours actifs répartis en plusieurs disciplines. Affrontez vos amis, montrez ce que vous savez faire — et remportez des trophées décernés publiquement devant toute la communauté. Chaque semaine, de nouveaux défis.",
      "statDisciplines": "Disciplines",
      "statConcours": "Concours",
      "statHebdo": "Hebdomadaire",
      "trophyBanner": "Votre talent mérite d'être vu · Votre victoire mérite d'être célébrée",
      "hint": "Appuyez sur une discipline pour commencer",
      "ctaTrophies": "Trophées · Remis publiquement",
      "strategie": {
        "label": "Jeux Stratégiques",
        "tagline": "Réflexion & tactique pure",
        "desc": "Affrontez vos adversaires dans des duels de stratégie intense. Chaque victoire vous rapproche du podium.",
        "item1Name": "Awalé",
        "item1Sub": "L'art ancestral de la stratégie",
        "item2Name": "Dames",
        "item2Sub": "Dominez l'échiquier"
      },
      "connaissance": {
        "label": "Connaissances",
        "tagline": "Testez votre savoir",
        "desc": "Des duels intellectuels aussi palpitants qu'imprévisibles. La connaissance au sommet mérite sa couronne.",
        "item1Name": "Vrai ou Faux",
        "item1Sub": "Défiez vos amis à coups de vérités"
      },
      "arts": {
        "label": "Arts",
        "tagline": "Créativité & expression",
        "desc": "Votre regard, votre trait, votre style. Exposez vos créations et recevez la reconnaissance qu'elles méritent.",
        "item1Name": "Photo",
        "item1Sub": "Votre regard, votre signature",
        "item2Name": "Dessin",
        "item2Sub": "Votre trait, votre univers",
        "item3Name": "Design",
        "item3Sub": "L'esthétique au service de l'intention"
      },
      "performance": {
        "label": "Performance",
        "tagline": "Montez sur scène",
        "desc": "Incarnez, captivez, transcendez. La scène d'Harmonia vous attend pour votre consécration.",
        "item1Name": "Comédie",
        "item1Sub": "Le rire, l'art le plus universel",
        "item2Name": "Danse",
        "item2Sub": "Chaque mouvement raconte une histoire",
        "item3Name": "Théâtre",
        "item3Sub": "Incarnez, captivez, transcendez"
      },
      "musique": {
        "label": "Musique",
        "tagline": "Faites vibrer la scène",
        "desc": "Votre voix, vos instruments, votre empreinte dans le monde. Les grandes voix méritent leur ovation.",
        "item1Name": "Chant",
        "item1Sub": "Votre voix, votre instrument précieux",
        "item2Name": "Piano",
        "item2Sub": "88 touches, un univers infini",
        "item3Name": "Guitare",
        "item3Sub": "Chaque accord, une déclaration"
      },
      "artisanat": {
        "label": "Artisanat",
        "tagline": "Savoir-faire d'excellence",
        "desc": "Des métiers nobles, une maîtrise rare. L'excellence artisanale mérite son podium et sa reconnaissance.",
        "item1Name": "Couture",
        "item1Sub": "L'art qui habille le monde",
        "item2Name": "Menuiserie",
        "item2Sub": "Le bois entre vos mains devient œuvre",
        "item3Name": "Coiffure",
        "item3Sub": "Sublimer, transformer, révéler",
        "item4Name": "Soudure",
        "item4Sub": "La précision qui unit les métaux",
        "item5Name": "Mécanique",
        "item5Sub": "La science qui fait tourner le monde"
      }
    },
    "challenge": {
      "chip": "DÉFIS & CONCOURS",
      "title": "Des concours pour vous sublimer",
      "sub": "Chaque discipline ouvre la porte à des concours hebdomadaires. Stratégie, arts, musique, performance, artisanat — votre domaine d'excellence a forcément sa compétition sur Harmonia.",
      "subMobile": "Chaque discipline ouvre la porte à des concours hebdomadaires. Votre domaine d'excellence a sa compétition sur Harmonia.",
      "cta": "Relever un défi"
    },
    "community": {
      "chip": "COMMUNAUTÉ",
      "titleLine1": "Une famille",
      "titleLine2": "inspirante",
      "sub": "Rejoignez une mosaïque de talents. Que vous soyez là pour partager une œuvre, trouver l'inspiration ou construire l'avenir, vous y trouverez votre place.",
      "cta": "Rejoindre la communauté"
    },
    "final": {
      "titleLine1": "Votre moment",
      "titleLine2": "est venu",
      "sub": "Ne laissez plus votre potentiel en attente.\nFaites résonner votre voix dès aujourd'hui.",
      "cta": "Créer mon profil créatif",
      "note": "L'aventure commence ici · Accès immédiat · Gratuit"
    },
    "footer": {
      "tagline": "Cultivons l'inspiration, ensemble.",
      "copyright": "Tous droits réservés"
    }
  },
  "login": {
    "common": {
      "tagline": "Révélez Votre Talent",
      "or": "ou",
      "continueWithGoogle": "Continuer avec Google",
      "needHelp": "Besoin d'aide ?",
      "loading": "Chargement...",
      "emailPlaceholder": "Email",
      "passwordPlaceholder": "Mot de passe"
    },
    "login": {
      "title": "Connexion",
      "subtitle": "Bienvenue ! Connectez-vous pour continuer",
      "forgotPassword": "Mot de passe oublié ?",
      "submit": "Se connecter",
      "noAccountPrefix": "Pas encore inscrit ?",
      "noAccountLink": "Créer un compte"
    },
    "signup": {
      "title": "Inscription",
      "subtitle": "Créez votre compte Harmonia",
      "lastNamePlaceholder": "Nom",
      "firstNamePlaceholder": "Prénom",
      "passwordPlaceholder": "Mot de passe (min. 6 caractères)",
      "submit": "Créer mon compte",
      "alreadyAccountPrefix": "Déjà un compte ?",
      "alreadyAccountLink": "Se connecter"
    },
    "verify": {
      "title": "Vérifiez votre email",
      "subtitle": "Un lien de confirmation a été envoyé à",
      "step1": "Consultez votre boîte mail",
      "step2": "Cliquez sur le lien de confirmation",
      "step3": "Revenez ici et cliquez sur \"Vérifier\"",
      "submit": "Vérifier l'activation",
      "backToSignup": "Retour à l'inscription"
    },
    "reset": {
      "title": "Mot de passe oublié",
      "subtitle": "Entrez votre email pour recevoir un lien de réinitialisation",
      "submit": "Envoyer le lien",
      "backToLogin": "Retour à la connexion",
      "confirm": {
        "checkingLink": "Vérification du lien...",
        "title": "Nouveau mot de passe",
        "subtitle": "Choisissez un nouveau mot de passe sécurisé pour votre compte.",
        "newPasswordPlaceholder": "Nouveau mot de passe",
        "confirmPasswordPlaceholder": "Confirmer le mot de passe",
        "submit": "Réinitialiser mon mot de passe",
        "backToLogin": "Retour à la connexion",
        "backToLoginArrow": "← Retour à la connexion",
        "invalidLink": {
          "title": "Lien invalide",
          "subtitle": "Ce lien est invalide ou a expiré.\nVeuillez refaire une demande de réinitialisation."
        },
        "messages": {
          "fillBothFields": "Veuillez remplir les deux champs",
          "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
          "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
          "resetting": "Réinitialisation en cours...",
          "resetError": "Erreur lors de la réinitialisation",
          "passwordChanged": "Mot de passe modifié avec succès !",
          "cannotResetPassword": "Impossible de réinitialiser le mot de passe"
        }
      }
    },
    "confirmGoogle": {
      "title": "Confirmer l'identité",
      "subtitle": "Continuer en tant que",
      "submit": "Continuer",
      "cancel": "Annuler"
    },
    "terms": {
      "prefix": "J'ai lu et j'accepte les ",
      "cgu": "Conditions d'utilisation",
      "middle": ", la ",
      "privacy": "Politique de confidentialité",
      "and": " et les ",
      "community": "Règles communautaires"
    },
    "google": {
      "defaultUser": "Utilisateur"
    },
    "messages": {
      "mustAcceptTerms": "Vous devez accepter les conditions d'utilisation pour continuer",
      "fillAllFields": "Veuillez remplir tous les champs",
      "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
      "invalidDate": "Format de date invalide",
      "registrationsClosed": "Les inscriptions sont actuellement fermées.",
      "cannotVerifyRegistrations": "Impossible de vérifier les inscriptions.",
      "cannotReachServer": "Impossible de joindre le serveur.",
      "creatingAccount": "Création du compte en cours...",
      "signupError": "Erreur lors de l'inscription",
      "accountCreated": "Compte créé ! Vérifiez votre email.",
      "cannotCreateAccount": "Impossible de créer le compte",
      "verifying": "Vérification en cours...",
      "verificationError": "Erreur de vérification",
      "emailVerified": "Email vérifié ! Bienvenue sur Harmonia !",
      "emailNotVerified": "Email non vérifié. Cliquez sur le lien dans votre email.",
      "cannotVerifyEmail": "Impossible de vérifier l'email",
      "enterEmailPassword": "Veuillez entrer votre email et mot de passe",
      "loggingIn": "Connexion en cours...",
      "emailNotConfirmed": "Email non confirmé. Vérifiez votre boîte mail.",
      "incorrectCredentials": "Identifiants incorrects",
      "loginSuccess": "Connexion réussie ! Bienvenue !",
      "cannotLogin": "Impossible de se connecter",
      "enterEmail": "Veuillez entrer votre email",
      "sendingEmail": "Envoi de l'email en cours...",
      "noAccountWithEmail": "Aucun compte avec cet email",
      "resetRequestError": "Erreur lors de la demande",
      "linkSent": "Lien envoyé ! Consultez votre boîte mail.",
      "cannotSendEmail": "Impossible d'envoyer l'email",
      "googleWebFailed": "Connexion Google web échouée",
      "googleTokenMissing": "Token d'authentification Google manquant",
      "googleCancelled": "Connexion Google annulée",
      "googleFailed": "La connexion Google n'a pas pu aboutir",
      "googleInProgress": "Connexion Google déjà en cours",
      "playServicesUnavailable": "Les services Google Play ne sont pas disponibles",
      "googleError": "Erreur lors de la connexion Google",
      "certifyingIdentity": "Certification de votre identité...",
      "googleServerValidationFailed": "Échec de la validation Google côté serveur",
      "welcomeUser": "Bienvenue, {{name}} !",
      "googleFinalizeError": "Impossible de finaliser la connexion Google"
    }
  },
  "guide": {
    "header": {
      "title": "Guide d'utilisation",
      "gotIt": "J'ai compris !"
    },
    "guides": {
      "create": {
        "tabLabel": "Créer",
        "title": "Créer mon compte Harmonia",
        "step1": "Appuyez sur « Créer un compte » en bas de l'écran de connexion.",
        "step2": "Renseignez votre nom, prénom et date de naissance.",
        "step3": "Entrez votre adresse email valide.",
        "step4": "Choisissez un mot de passe d'au moins 6 caractères.",
        "step5": "Cochez la case pour accepter les Conditions d'utilisation, la Politique de confidentialité et les Règles communautaires.",
        "step6": "Le bouton « Créer mon compte » devient actif — appuyez dessus.",
        "step7": "Vérifiez votre boîte mail et cliquez sur le lien de confirmation reçu.",
        "step8": "Revenez sur l'app et appuyez sur « Vérifier l'activation » pour finaliser."
      },
      "login": {
        "tabLabel": "Connexion",
        "title": "Me connecter à Harmonia",
        "step1": "Entrez votre adresse email dans le premier champ.",
        "step2": "Saisissez votre mot de passe dans le second champ.",
        "step3": "Utilisez l'icône 👁 pour afficher ou masquer votre mot de passe.",
        "step4": "Appuyez sur le bouton « Se connecter ».",
        "step5": "Vous êtes redirigé vers votre espace Harmonia !"
      },
      "reset": {
        "tabLabel": "MDP oublié",
        "title": "Mot de passe oublié",
        "step1": "Sur l'écran de connexion, appuyez sur « Mot de passe oublié ? ».",
        "step2": "Entrez l'adresse email liée à votre compte Harmonia.",
        "step3": "Appuyez sur « Envoyer le lien ».",
        "step4": "Consultez votre boîte mail (vérifiez aussi les spams !).",
        "step5": "Cliquez sur le lien de réinitialisation reçu par email.",
        "step6": "Définissez votre nouveau mot de passe puis connectez-vous.",
        "note": "⏱ Le lien expire rapidement. Agissez dès réception de l'email !"
      },
      "google": {
        "tabLabel": "Google",
        "title": "Se connecter avec Google",
        "step1": "Appuyez sur « Continuer avec Google » sur l'écran de connexion ou d'inscription.",
        "step2": "Sélectionnez votre compte Google dans la fenêtre qui s'ouvre.",
        "step3": "Vérifiez les informations affichées puis appuyez sur « Continuer ».",
        "step4": "Vous êtes connecté à Harmonia !",
        "note": "💡 Pour l'inscription via Google, cochez d'abord les Conditions d'utilisation avant d'appuyer sur le bouton Google."
      },
      "verify": {
        "tabLabel": "Email",
        "title": "Vérification de l'email",
        "step1": "Après inscription, un email de confirmation vous est envoyé automatiquement.",
        "step2": "Ouvrez votre boîte mail et vérifiez aussi les spams / courriers indésirables.",
        "step3": "Cliquez sur le bouton « Confirmer mon email » dans l'email reçu.",
        "step4": "Revenez dans l'application Harmonia.",
        "step5": "Appuyez sur « Vérifier l'activation » pour finaliser votre inscription.",
        "note": "⚠️ Le lien est valable 24 h. Si expiré, recommencez l'inscription depuis le début."
      }
    }
  },
  "notifications": {
    "header": {
      "subtitle": "Centre de notifications"
    },
    "tabs": {
      "notifs": "Notifications",
      "last24h": "Info 24h",
      "trophees": "Trophées"
    },
    "time": {
      "now": "À l'instant",
      "minutes_one": "{{count}} min",
      "minutes_other": "{{count}} min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}j",
      "days_other": "{{count}}j"
    },
    "types": {
      "friendRequest": "Demande d'ami",
      "friendAccepted": "Ami accepté",
      "like": "Like",
      "comment": "Commentaire",
      "report": "Signalement",
      "postStatus": "Statut",
      "default": "Annonce"
    },
    "error": {
      "notConnected": "Non connecté",
      "generic": "Erreur {{status}}",
      "retry": "Réessayer"
    },
    "loading": {
      "default": "Chargement…",
      "info24h": "Chargement en cours…",
      "info24hFull": "Chargement des 24 dernières heures…"
    },
    "markAll": {
      "action": "Tout marquer comme lu"
    },
    "empty": {
      "notifs": {
        "title": "Aucune notification",
        "sub": "Vous serez informé des activités ici."
      },
      "last24h": {
        "title": "Aucune activité récente",
        "sub": "Aucune notification enregistrée au cours des dernières 24 heures."
      },
      "trophees": {
        "title": "Aucun trophée",
        "sub": "Participez aux sessions pour en remporter !"
      }
    },
    "more": {
      "loadOlder": "Charger les anciennes"
    },
    "end": {
      "upToDate": "Vous êtes à jour"
    },
    "info24h": {
      "title": "Activité des dernières 24h",
      "count_one": "{{count}} notification récente",
      "count_other": "{{count}} notifications récentes",
      "unread_one": "{{count}} non lue",
      "unread_other": "{{count}} non lues"
    },
    "card": {
      "grouped_one": "{{count}} événement regroupé",
      "grouped_other": "{{count}} événements regroupés"
    },
    "trophy": {
      "won_one": "trophée remporté",
      "won_other": "trophées remportés",
      "awardedBy": "Décerné par {{firstName}} {{lastName}}"
    }
  },
  "editPostModal": {
    "errors": {
      "sessionNotFound": "Session introuvable",
      "accessTokenMissing": "access_token manquant"
    },
    "deleteConfirm": {
      "title": "Supprimer le post ?",
      "text": "Cette action est irréversible. Le post sera définitivement supprimé.",
      "cancel": "Annuler",
      "confirm": "Supprimer"
    },
    "menu": {
      "title": "Options du post",
      "edit": "Modifier",
      "delete": "Supprimer",
      "cancel": "Annuler"
    },
    "edit": {
      "title": "Modifier le post",
      "placeholder": "Quoi de neuf ?",
      "save": "Enregistrer"
    }
  },
  "logoutModal": {
    "errors": {
      "sessionNotFound": "Session introuvable"
    },
    "memory": {
      "title": "Mémoriser ce compte ?",
      "message": "Souhaitez-vous mémoriser ce compte pour vous reconnecter plus rapidement la prochaine fois, sans ressaisir votre mot de passe ?",
      "no": "Non",
      "yes": "Oui"
    },
    "confirm": {
      "title": "Se déconnecter ?",
      "message": "Êtes-vous sûr de vouloir vous déconnecter de votre compte ?",
      "cancel": "Annuler",
      "submit": "Déconnexion"
    }
  },
  "commentsModal": {
    "errors": {
      "sessionNotFound": "Session introuvable",
      "accessTokenMissing": "access_token manquant",
      "sendError": "Erreur lors de l'envoi",
      "title": "Erreur",
      "networkError": "Erreur réseau, veuillez réessayer",
      "networkErrorTitle": "Erreur réseau",
      "tryAgain": "Veuillez réessayer"
    },
    "time": {
      "now": "À l'instant",
      "minutes_one": "il y a {{count}}min",
      "minutes_other": "il y a {{count}}min",
      "hours_one": "il y a {{count}}h",
      "hours_other": "il y a {{count}}h",
      "days_one": "il y a {{count}}j",
      "days_other": "il y a {{count}}j"
    },
    "likesCount_one": "{{count}} like",
    "likesCount_other": "{{count}} likes",
    "liked": "Aimé",
    "like": "Aimer",
    "reply": "Répondre",
    "header": {
      "title": "Commentaires"
    },
    "empty": {
      "title": "Aucun commentaire",
      "subtitle": "Soyez le premier à commenter !"
    },
    "replyingTo": "Répondre à {{name}}",
    "replyPlaceholder": "Répondre à {{name}}...",
    "addPlaceholder": "Ajouter un commentaire..."
  },
  "groupsTab": {
    "time": {
      "now": "À l'instant",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}j",
      "days_other": "{{count}}j"
    },
    "loadingData": "Chargement des données",
    "tabs": {
      "mine_one": "Mes groupes ({{count}})",
      "mine_other": "Mes groupes ({{count}})",
      "explore": "Explorer"
    },
    "empty": {
      "noResults": "Aucun résultat",
      "noResultsFor": "Aucun groupe pour « {{query}} »",
      "noGroups": "Vous n'êtes dans aucun groupe",
      "exploreCta": "Explorer les groupes",
      "noGroupsAvailable": "Aucun groupe disponible"
    },
    "lastMessage": "{{sender}} : {{content}}",
    "memberCount_one": "{{count}} membre",
    "memberCount_other": "{{count}} membres",
    "you": "Vous",
    "open": "Ouvrir",
    "join": "Rejoindre",
    "joining": "..."
  },
  "infoBanner": {
    "previous": "Précédent",
    "next": "Suivant",
    "closeAndResume": "Fermer et reprendre",
    "news": "Actualité",
    "reduceAndResume": "Réduire et reprendre la lecture"
  },
  "pushPromptModal": {
    "title": "Restez informé !",
    "subtitle": "Recevez les annonces importantes, vos trophées et les nouvelles sessions d'Harmonia directement sur votre appareil.",
    "icons": {
      "trophies": "Trophées",
      "announcements": "Annonces",
      "sessions": "Sessions"
    },
    "enableButton": "Activer les notifications",
    "dismissButton": "Ignorer ({{count}}s)"
  },
  "savedPostsModal": {
    "time": {
      "now": "À l'instant",
      "minutes_one": "il y a {{count}}min",
      "minutes_other": "il y a {{count}}min",
      "hours_one": "il y a {{count}}h",
      "hours_other": "il y a {{count}}h",
      "days_one": "il y a {{count}}j",
      "days_other": "il y a {{count}}j"
    },
    "header": {
      "title": "Posts sauvegardés"
    },
    "syncing": "Synchronisation en cours…",
    "tapToPlay": "Appuyer pour lire",
    "commentsCount_one": "{{count}} commentaire",
    "commentsCount_other": "{{count}} commentaires",
    "sharesCount_one": "{{count}} partage",
    "sharesCount_other": "{{count}} partages",
    "empty": {
      "title": "Aucun post sauvegardé",
      "subtitle": "Les posts que vous enregistrez apparaîtront ici"
    }
  },
  "sharersModal": {
    "time": {
      "now": "À l'instant",
      "minutes_one": "il y a {{count}}min",
      "minutes_other": "il y a {{count}}min",
      "hours_one": "il y a {{count}}h",
      "hours_other": "il y a {{count}}h",
      "days_one": "il y a {{count}}j",
      "days_other": "il y a {{count}}j"
    },
    "errors": {
      "sessionExpired": "Session expirée",
      "loadFailed": "Impossible de charger les partages"
    },
    "sharedAt": "Partagé {{time}}",
    "header": {
      "title": "Partages",
      "titleWithCount": "Partages ({{count}})"
    },
    "loading": "Chargement...",
    "retry": "Réessayer",
    "empty": "Aucun partage pour l'instant"
  },
  "searchModal": {
    "time": {
      "now": "À l'instant",
      "minutes_one": "il y a {{count}}min",
      "minutes_other": "il y a {{count}}min",
      "hours_one": "il y a {{count}}h",
      "hours_other": "il y a {{count}}h",
      "days_one": "il y a {{count}}j",
      "days_other": "il y a {{count}}j"
    },
    "categories": {
      "all": "Tout",
      "posts": "Publications",
      "images": "Images",
      "videos": "Vidéos",
      "music": "Musique",
      "artisanat": "Artisanat"
    },
    "tapToPlay": "Appuyer pour lire",
    "commentsCount_one": "{{count}} commentaire",
    "commentsCount_other": "{{count}} commentaires",
    "sharesCount_one": "{{count}} partage",
    "sharesCount_other": "{{count}} partages",
    "status": {
      "submissions": "Soumissions",
      "votingOpen": "Vote ouvert",
      "finished": "Terminé"
    },
    "media": {
      "image": "image",
      "track": "piste",
      "video": "vidéo",
      "hide": "Masquer",
      "viewCount_one": "Voir {{count}} {{label}}",
      "viewCount_other": "Voir {{count}} {{label}}s"
    },
    "runNumber": "Run #{{number}}",
    "voted": "Voté",
    "vote": "Voter",
    "votesCount_one": "{{count}} vote",
    "votesCount_other": "{{count}} votes",
    "header": {
      "title": "Rechercher"
    },
    "placeholder": "Mots-clés, descriptions, titres…",
    "searchButton": "Rechercher",
    "searching": "Recherche en cours…",
    "noResults": {
      "title": "Aucun résultat",
      "subtitle": "Essayez avec d'autres mots-clés"
    },
    "resultsCount_one": "{{count}} résultat",
    "resultsCount_other": "{{count}} résultats",
    "intro": {
      "title": "Rechercher dans Harmonia",
      "subtitle": "Publications, vidéos, images, sons…\nChoisissez une catégorie et tapez vos mots-clés"
    }
  },
  "userProfileView": {
    "time": {
      "now": "À l'instant",
      "minutes_one": "il y a {{count}}min",
      "minutes_other": "il y a {{count}}min",
      "hours_one": "il y a {{count}}h",
      "hours_other": "il y a {{count}}h",
      "days_one": "il y a {{count}}j",
      "days_other": "il y a {{count}}j"
    },
    "tapToPlay": "Appuyer pour lire",
    "commentsCount_one": "{{count}} commentaire",
    "commentsCount_other": "{{count}} commentaires",
    "sharesCount_one": "{{count}} partage",
    "sharesCount_other": "{{count}} partages",
    "loading": "Chargement...",
    "profileNotFound": "Profil introuvable",
    "retry": "Réessayer",
    "memberSince": "Membre depuis {{date}}",
    "friendsLabel": "Amis",
    "trophiesLabel": "Trophées",
    "friend": {
      "add": "Ajouter ami",
      "pending": "En attente",
      "accept": "Accepter",
      "remove": "Retirer ami"
    },
    "viewPosts": "Voir les publications",
    "postsCount": "Publications ({{count}})",
    "noPosts": "Aucune publication",
    "notFriend": {
      "pendingSent": "Demande envoyée — En attente de confirmation",
      "pendingReceived": "Acceptez la demande pour voir les publications",
      "none": "Ajoutez cet utilisateur comme ami pour voir ses publications"
    }
  },
  "cgu": {
    "title": "Conditions Générales d'Utilisation",
    "stats": {
      "sections": "Sections",
      "law": "Droit béninois",
      "compliant": "Conforme"
    },
    "sections": {
      "presentation": {
        "title": "Présentation de la plateforme",
        "p1": "Harmonia est une plateforme sociale mondiale, disponible sur le web et sur mobile, permettant à ses membres de créer un profil, publier du contenu, interagir via la messagerie et les groupes, participer à des concours de talents, jouer à des jeux de culture générale et de stratégie, et créer une boutique en ligne pour les utilisateurs PRO.",
        "p2": "Harmonia est développée et exploitée par une entité enregistrée au Bénin.",
        "highlight1": "En accédant à la plateforme et en créant un compte, vous acceptez sans réserve les présentes CGU."
      },
      "inscription": {
        "title": "Accès et inscription",
        "sub1": "Création de compte",
        "p1": "L'accès aux fonctionnalités de Harmonia nécessite la création d'un compte. L'inscription est ouverte à toute personne dans le monde entier, sans restriction d'âge.",
        "bullets1": [
          "Inscription directe : nom, prénom, adresse e-mail et date de naissance",
          "Via fournisseur tiers (Google, Facebook, etc.) : nom, prénom et adresse e-mail. La date de naissance peut être complétée ultérieurement."
        ],
        "sub2": "Exactitude des informations",
        "p2": "Vous vous engagez à fournir des informations exactes et à jour lors de votre inscription. Harmonia ne saurait être tenue responsable des conséquences liées à des informations inexactes.",
        "sub3": "Rester connecté",
        "highlight1": "Vous pouvez choisir de rester connecté à votre compte sans ressaisir votre mot de passe à chaque ouverture de l'application. Ce choix vous appartient exclusivement et reste modifiable à tout moment.",
        "sub4": "Mineurs",
        "highlight2": "Pour toute souscription à un service payant (abonnement, concours payant, boutique pro), un utilisateur mineur doit obtenir le consentement explicite de son parent ou tuteur légal avant tout achat."
      },
      "publications": {
        "title": "Publications et contenu",
        "sub1": "Limite quotidienne",
        "bullets1": [
          "Utilisateurs standards : 1 publication par jour",
          "Utilisateurs PRO : 3 publications par jour"
        ],
        "p1": "Cette limite encourage la qualité et la pertinence des contenus partagés sur la plateforme.",
        "sub2": "Niveaux de visibilité",
        "bullets2": [
          "PRO — visible par toute la communauté Harmonia (fonctionnalité payante)",
          "Amis — visible uniquement par vos amis",
          "Amis d'amis — visible par vos amis et leurs amis",
          "Privé — visible uniquement par vous"
        ],
        "sub3": "Contenu interdit",
        "bullets3": [
          "Contenu sexuel explicite ou nudité",
          "Contenu haineux, discriminatoire ou incitant à la violence",
          "Fausses informations délibérées et malveillantes",
          "Atteinte aux droits de propriété intellectuelle d'un tiers",
          "Contenu illégal en vertu des lois applicables"
        ],
        "sub4": "Propriété intellectuelle",
        "highlight1": "Vous conservez l'entière propriété de vos contenus. Harmonia ne revendique aucun droit sur vos créations et ne les utilisera jamais à des fins promotionnelles sans votre consentement.",
        "sub5": "Responsabilité",
        "p2": "Chaque utilisateur est seul et entièrement responsable des contenus qu'il publie. Harmonia se dégage de toute responsabilité pour les contenus publiés par ses membres."
      },
      "abonnements": {
        "title": "Abonnements et paiements",
        "sub1": "Fonctionnalités payantes",
        "bullets1": [
          "Visibilité PRO : diffuser une publication à l'ensemble de la communauté",
          "Création d'une boutique pro et publication de produits associés",
          "Consommation de données à des fins personnelles",
          "Participation à des concours payants"
        ],
        "sub2": "Moyens de paiement",
        "p1": "Harmonia accepte plusieurs moyens de paiement : paiement mobile, carte bancaire, et d'autres moyens progressivement intégrés.",
        "sub3": "Politique de non-remboursement",
        "highlight1": "Tout achat est définitif. Dès lors qu'un service a été accordé et utilisé, aucun remboursement ne sera effectué, même en cas de suspension du contenu, de la boutique pro ou d'un produit pour violation des règles."
      },
      "messagerie": {
        "title": "Messagerie et interactions",
        "sub1": "Messagerie privée",
        "p1": "La messagerie privée est strictement confidentielle et accessible uniquement aux participants de chaque conversation.",
        "sub2": "Groupes de discussion",
        "p2": "Harmonia met à disposition des groupes de discussion communautaires. Au sein de ces groupes, les utilisateurs peuvent également s'écrire en privé.",
        "highlight1": "Les règles de respect et de bienveillance s'appliquent également dans la messagerie privée."
      },
      "publicite": {
        "title": "Publicité",
        "p1": "En utilisant Harmonia, vous acceptez de recevoir des publications publicitaires intégrées dans la plateforme.",
        "highlight1": "Ces publicités proviennent exclusivement d'utilisateurs ayant souscrit à un abonnement publicitaire Harmonia. Aucune régie externe n'est utilisée."
      },
      "concours": {
        "title": "Concours de talents",
        "sub1": "Domaines couverts",
        "bullets1": [
          "Arts visuels : dessin, photographie",
          "Arts de la scène : comédie, danse",
          "Musique : piano et autres instruments",
          "Savoir-faire : activités artisanales et métiers",
          "Jeux de stratégie : dames, Awalé et autres",
          "Culture générale : Vrai ou Faux et autres formats"
        ],
        "highlight1": "Harmonia ne propose aucun jeu de hasard. L'objectif exclusif est de récompenser les talents réels.",
        "sub2": "Système de vote",
        "p1": "Le passage à l'étape physique est déterminé par les votes de la communauté. Le vote est gratuit, ouvert à tous les utilisateurs authentifiés, et limité à un seul vote par candidat.",
        "sub3": "Étape physique finale",
        "p2": "Les finales peuvent se tenir partout dans le monde. Les pays hôtes et les jurys experts sont sélectionnés aléatoirement par Harmonia pour garantir l'équité. Les récompenses incluent trophées, prix en argent, cadeaux et autres distinctions annoncées pour chaque concours.",
        "sub4": "Information en temps réel",
        "highlight2": "Tous les utilisateurs reçoivent des informations en temps réel sur le déroulement des concours et sur l'activité de la plateforme, afin que chacun soit informé équitablement."
      },
      "boutiques": {
        "title": "Boutiques pro",
        "sub1": "Description du service",
        "p1": "Les utilisateurs PRO peuvent créer une boutique sur la plateforme, accessible depuis Harmonia et via un lien URL public fonctionnel sur le web. Ils peuvent personnaliser le design et de nombreux paramètres du site associé à leur boutique.",
        "highlight1": "Chaque produit publié dans une boutique dispose également de son propre lien web permettant sa consultation directe.",
        "sub2": "Propriété et responsabilité",
        "p2": "L'utilisateur PRO conserve la propriété du contenu de sa boutique et en est seul et entièrement responsable, y compris vis-à-vis des personnes qui consulteraient ses liens web en dehors de Harmonia.",
        "sub3": "Conformité et suspension",
        "p3": "Le contenu de la boutique et des produits est soumis aux mêmes règles que le reste de la plateforme (contenu interdit, règles communautaires). Harmonia peut suspendre une boutique, un produit ou désactiver un lien web en cas de non-conformité, sans droit à remboursement."
      },
      "moderation": {
        "title": "Modération et signalement",
        "sub1": "Signalement",
        "p1": "Tout utilisateur peut signaler un contenu contraire aux règles, y compris le contenu d'une boutique pro ou d'un produit publié. Lorsqu'un contenu reçoit un nombre significatif de signalements, il passe automatiquement en état d'examen et n'est plus visible publiquement.",
        "sub2": "Décision des administrateurs",
        "bullets1": [
          "Contenu conforme : il retrouve sa visibilité normale",
          "Contenu non conforme : il est suspendu définitivement et sans appel"
        ],
        "highlight1": "Harmonia ne procède pas au bannissement des utilisateurs. Les mesures de modération portent sur les contenus, non sur les personnes."
      },
      "api": {
        "title": "Protection de l'API et des systèmes",
        "p1": "L'API backend de Harmonia et l'ensemble de ses systèmes techniques sont des propriétés exclusives de la plateforme. L'accès à l'API est strictement réservé aux applications officielles Harmonia.",
        "sub1": "Actes interdits",
        "bullets1": [
          "Accéder à l'API en dehors des applications officielles",
          "Contourner les mécanismes d'authentification ou de sécurité",
          "Intercepter les échanges entre les applications et les serveurs",
          "Utiliser des robots, scripts automatisés ou outils de scraping",
          "Effectuer des attaques DDoS ou toute action perturbant la plateforme",
          "Exploiter des failles techniques à des fins malveillantes",
          "Reproduire ou redistribuer des données issues de la plateforme"
        ],
        "sub2": "Poursuites judiciaires",
        "highlight1": "Toute violation constitue une infraction grave passible de poursuites judiciaires. Harmonia coopérera avec les autorités compétentes de tout pays pour identifier et poursuivre les contrevenants.",
        "sub3": "Signalement responsable",
        "p2": "Si vous découvrez une faille de sécurité, signalez-la immédiatement à harmonia@harmoniaworld.world sans l'exploiter. Harmonia traitera tout signalement de bonne foi de manière sérieuse et confidentielle."
      },
      "disponibilite": {
        "title": "Disponibilité de la plateforme",
        "p1": "Harmonia s'efforce d'assurer une disponibilité optimale. Des interruptions peuvent survenir pour des raisons de maintenance, de mise à jour ou de circonstances techniques indépendantes de notre volonté.",
        "p2": "Harmonia ne saurait être tenue responsable de ces interruptions."
      },
      "modifications": {
        "title": "Modification des CGU",
        "p1": "Harmonia se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification substantielle via la plateforme.",
        "highlight1": "La poursuite de l'utilisation après modification vaut acceptation des nouvelles conditions."
      },
      "droit": {
        "title": "Droit applicable et juridiction",
        "p1": "Les présentes CGU sont régies par le droit béninois. En cas de litige, et à défaut de résolution amiable, les tribunaux compétents du Bénin seront saisis."
      },
      "contact": {
        "title": "Contact",
        "p1": "Pour tout guide d'utilisation de la plateforme, consultez notre documentation disponible directement sur Harmonia."
      }
    }
  },
  "confidentialite": {
    "title": "Politique de Confidentialité",
    "stats": {
      "sections": "Sections",
      "gdpr": "RGPD Conforme",
      "secure": "Données sécurisées"
    },
    "sections": {
      "intro": {
        "title": "Introduction",
        "p1": "Harmonia est une plateforme sociale mondiale disponible sur le web et sur mobile, permettant à ses utilisateurs de publier du contenu, d'interagir, de participer à des concours et de jouer à des jeux de culture générale et de stratégie.",
        "p2": "La présente Politique de confidentialité vous informe de manière transparente sur les données que nous collectons, la façon dont nous les utilisons, vos droits et les mesures prises pour protéger votre vie privée.",
        "highlight1": "En utilisant Harmonia, vous acceptez les pratiques décrites dans cette politique."
      },
      "responsable": {
        "title": "Responsable du traitement",
        "p1": "Le responsable du traitement des données personnelles collectées via Harmonia est l'équipe dirigeante de la plateforme Harmonia, entité enregistrée au Bénin.",
        "p2": "Pour toute question relative à vos données personnelles, à l'exercice de vos droits, ou pour toute réclamation, contactez-nous directement à cette adresse."
      },
      "donnees": {
        "title": "Données collectées",
        "sub1": "Inscription directe",
        "bullets1": [
          "Nom et prénom",
          "Adresse e-mail",
          "Date de naissance"
        ],
        "sub2": "Via fournisseur tiers (Google, Facebook, etc.)",
        "bullets2": [
          "Nom et prénom",
          "Adresse e-mail",
          "Date de naissance (à compléter ultérieurement)"
        ],
        "sub3": "Données de profil & contenu publié",
        "p1": "Vous maîtrisez la visibilité de chaque information de votre profil et de chaque publication (PRO, Amis, Amis d'amis, Privé).",
        "sub4": "Messagerie",
        "p2": "Les messages privés et discussions de groupe sont strictement confidentiels, accessibles uniquement aux participants de chaque conversation.",
        "sub5": "Données de paiement",
        "p3": "Traitées exclusivement par nos prestataires certifiés. Harmonia ne stocke jamais directement vos données bancaires.",
        "sub6": "Boutiques pro",
        "highlight1": "Les utilisateurs PRO peuvent créer une boutique avec un lien URL public. Nous collectons les informations de la boutique, les produits publiés (chacun avec son propre lien web) et les données de personnalisation du site associé."
      },
      "utilisation": {
        "title": "Utilisation des données",
        "bullets1": [
          "Gestion de votre compte et authentification",
          "Fonctionnalités sociales (publications, messagerie, amis, groupes)",
          "Concours, jeux et étapes finales physiques mondiales",
          "Diffusion en temps réel d'informations sur les concours et l'activité de la plateforme",
          "Gestion de vos abonnements et services payants",
          "Création et mise à disposition des boutiques pro et des liens web associés",
          "Application des limites de publication quotidiennes (1/jour standard, 3/jour PRO) pour renforcer la qualité de l'information",
          "Publicités internes provenant des utilisateurs abonnés",
          "Sécurité, prévention des fraudes et modération du contenu"
        ],
        "highlight1": "Nous nous engageons à ne jamais vendre, louer ou transmettre vos données à des tiers à des fins commerciales."
      },
      "concours": {
        "title": "Concours & Événements physiques",
        "p1": "Certains concours aboutissent à une étape finale physique organisée par Harmonia pouvant se tenir partout dans le monde.",
        "highlight1": "Harmonia ne collecte aucune donnée supplémentaire pour ces événements. Aucune pièce d'identité, adresse ou localisation n'est demandée.",
        "p2": "Les jurys experts et pays hôtes sont sélectionnés aléatoirement par Harmonia pour garantir l'équité et prévenir toute fraude.",
        "sub1": "Information en temps réel",
        "p3": "Harmonia diffuse en temps réel des informations sur le déroulement des concours, à partir des données déjà collectées dans le cadre normal de l'utilisation de la plateforme. Cette diffusion ne donne lieu à aucune collecte de données supplémentaire."
      },
      "publicite": {
        "title": "Publicité",
        "p1": "En utilisant Harmonia, vous acceptez de recevoir des publications publicitaires provenant exclusivement d'utilisateurs abonnés à un plan publicitaire Harmonia.",
        "highlight1": "Aucune régie externe. Aucune publicité de tiers extérieurs n'est diffusée sur Harmonia."
      },
      "securite": {
        "title": "Hébergement & Sécurité",
        "p1": "Vos données sont hébergées sur des serveurs situés en Europe, dans le respect des normes de sécurité en vigueur.",
        "bullets1": [
          "Chiffrement des données sensibles",
          "Accès restreint aux données selon les rôles",
          "Surveillance continue de l'infrastructure",
          "Limitation du nombre de publications quotidiennes, pour prévenir les comportements abusifs"
        ],
        "sub1": "Protection de l'API et des systèmes techniques",
        "p2": "L'API backend de Harmonia est réservée à un usage interne exclusif. Tout accès non autorisé est interdit et passible de poursuites judiciaires. Harmonia collecte les logs techniques (connexions, adresses IP) pour détecter et poursuivre tout accès frauduleux."
      },
      "partage": {
        "title": "Partage des données",
        "highlight1": "Vos données ne sont jamais partagées à des fins commerciales ou publicitaires externes.",
        "bullets1": [
          "Prestataires techniques soumis à des obligations contractuelles strictes de confidentialité",
          "Obligations légales (procédure judiciaire ou réquisition d'autorité compétente)"
        ],
        "p1": "Le contenu d'une boutique pro (produits, description, personnalisation) est rendu accessible publiquement via son lien web dès lors que l'utilisateur PRO choisit de publier sa boutique."
      },
      "mineurs": {
        "title": "Utilisateurs mineurs",
        "p1": "Harmonia est accessible à tous les utilisateurs sans restriction d'âge. Le talent n'a pas d'âge et la connaissance est pour tous.",
        "highlight1": "Pour tout service payant, un mineur doit obtenir le consentement explicite de son parent ou tuteur légal."
      },
      "droits": {
        "title": "Vos droits (RGPD)",
        "bullets1": [
          "Droit d'accès — consulter vos données",
          "Droit de rectification — corriger des données inexactes",
          "Droit à l'effacement — supprimer votre compte et vos données",
          "Droit à la portabilité — exporter vos données",
          "Droit d'opposition — à certains traitements",
          "Droit de retrait du consentement à tout moment"
        ],
        "highlight1": "Pour exercer vos droits : harmonia@harmoniaworld.world"
      },
      "conservation": {
        "title": "Conservation des données",
        "p1": "Vos données sont conservées pendant toute la durée de votre utilisation active de la plateforme.",
        "bullets1": [
          "Données identifiables supprimées à la clôture du compte",
          "Données anonymisées pouvant être conservées à des fins statistiques",
          "Boutique pro et produits associés supprimés à la clôture du compte ; les liens web associés cessent d'être fonctionnels"
        ]
      },
      "cookies": {
        "title": "Cookies & Technologies de suivi",
        "highlight1": "Aucun outil de suivi tiers (pas de Google Analytics, ni de traceurs publicitaires).",
        "p1": "Seuls des cookies techniques essentiels sont utilisés (session, authentification, sécurité). Sur mobile, des tokens d'authentification sécurisés sont stockés localement sur votre appareil, y compris lorsque vous choisissez de rester connecté."
      },
      "responsabilite": {
        "title": "Responsabilité des utilisateurs",
        "p1": "Chaque utilisateur est seul et entièrement responsable des contenus qu'il publie sur Harmonia, y compris le contenu d'une boutique pro et des liens web associés.",
        "p2": "Harmonia se réserve le droit de suspendre tout contenu non conforme après examen par ses administrateurs, y compris une boutique pro ou un produit publié."
      },
      "modifications": {
        "title": "Modifications de la politique",
        "p1": "Harmonia se réserve le droit de modifier la présente politique à tout moment. En cas de modification substantielle, les utilisateurs seront notifiés via la plateforme.",
        "highlight1": "La poursuite de l'utilisation après modification vaut acceptation des nouvelles conditions."
      },
      "contact": {
        "title": "Contact",
        "p1": "Consultez également notre guide d'utilisation disponible directement sur Harmonia."
      }
    }
  },
  "guideScreen": {
    "header": {
      "title": "Guide d'utilisation",
      "subtitle": "Tout savoir sur Harmonia"
    },
    "intro": {
      "text": "Bienvenue sur le guide d'utilisation. Appuyez sur un chapitre pour le développer et découvrir comment utiliser chaque fonctionnalité.",
      "allMembers": "Tous les membres",
      "proFeatures": "Fonctions PRO"
    },
    "chapters": {
      "compte": {
        "title": "Connexion & Compte",
        "steps": {
          "step1": {
            "title": "Créer un compte",
            "desc": "Sur l'écran d'accueil, appuyez sur « Créer un compte ». Renseignez votre prénom, nom, adresse email et un mot de passe. Cochez les conditions d'utilisation, puis appuyez sur « S'inscrire »."
          },
          "step2": {
            "title": "Vérifier votre email",
            "desc": "Après l'inscription, un email de vérification vous est envoyé. Ouvrez-le et cliquez sur le lien pour activer votre compte, puis revenez sur l'application."
          },
          "step3": {
            "title": "Se connecter",
            "desc": "Entrez votre email et votre mot de passe, puis appuyez sur « Se connecter »."
          },
          "step4": {
            "title": "Rester connecté",
            "desc": "Vous pouvez choisir de rester connecté à votre compte. Dans ce cas, à chaque ouverture de l'application, vous arrivez directement sur le fil d'actualité sans avoir à ressaisir votre mot de passe. Ce choix vous appartient à tout moment : si vous vous déconnectez explicitement sans avoir activé cette option, vous retrouverez l'écran de connexion à la prochaine ouverture."
          },
          "step5": {
            "title": "Mot de passe oublié",
            "desc": "Sur l'écran de connexion, appuyez sur « Mot de passe oublié ». Entrez votre email. Vous recevrez un code à 6 chiffres. Saisissez-le, puis créez un nouveau mot de passe."
          },
          "step6": {
            "title": "Connexion avec Google",
            "desc": "Appuyez sur « Continuer avec Google » pour vous connecter en un clic. Lors de la première connexion, vous devrez accepter les conditions d'utilisation."
          }
        }
      },
      "actu": {
        "title": "Fil d'actualité",
        "steps": {
          "step1": {
            "title": "Naviguer dans le fil",
            "desc": "L'onglet Actu 🏠 affiche les publications de la communauté. Faites défiler vers le bas pour charger plus de contenu. Appuyez sur l'icône de filtre pour trier : Tout · Publications · Images · Vidéos · Musique."
          },
          "step2": {
            "title": "Masquer ou afficher le header",
            "desc": "Faites un double-tap sur la zone du header pour le masquer et gagner de l'espace de lecture. Recommencez pour le réafficher."
          },
          "step3": {
            "title": "Votre solde CFA",
            "desc": "Votre solde CFA est affiché dans le header. Appuyez dessus pour ouvrir directement l'écran de recharge et ajouter des fonds via Mobile Money."
          },
          "step4": {
            "title": "Actualiser le fil",
            "desc": "Glissez vers le bas depuis le haut du fil pour rafraîchir. Vous pouvez aussi appuyer sur l'icône de rafraîchissement 🔄 dans le header."
          },
          "step5": {
            "title": "Créer une publication",
            "desc": "Appuyez sur le bouton « + » dans le header. Rédigez votre message (max 1 000 caractères). Choisissez la visibilité : Public · Amis · Privé · PRO. Appuyez sur « Publier »."
          },
          "step6": {
            "title": "Ajouter une photo ou vidéo à sa publication",
            "desc": "Les membres PRO peuvent joindre une photo ou une vidéo à leurs publications. Un bouton 📷 Photo et 🎬 Vidéo apparaît dans le formulaire de création."
          },
          "step7": {
            "title": "Liker une publication",
            "desc": "Appuyez sur le pouce 👍 sous une publication pour l'aimer. Un reflet violet s'anime. Appuyez à nouveau pour annuler. Appuyez sur le compteur de likes pour voir la liste des personnes qui ont aimé."
          },
          "step8": {
            "title": "Commenter",
            "desc": "Appuyez sur l'icône 💬 pour ouvrir les commentaires de la publication. Rédigez votre réponse dans la zone de texte en bas et envoyez."
          },
          "step9": {
            "title": "Partager une publication",
            "desc": "Appuyez sur l'icône de partage 🔄 pour partager une publication publique dans le fil. Appuyez sur le nombre de partages affiché pour voir la liste des utilisateurs qui ont partagé."
          },
          "step10": {
            "title": "Sauvegarder une publication",
            "desc": "Appuyez sur l'icône 🔖 sous une publication pour la sauvegarder. Retrouvez toutes vos sauvegardes en appuyant sur l'icône dédiée dans le header."
          },
          "step11": {
            "title": "Signaler un contenu",
            "desc": "Appuyez sur l'icône de signalement ⚠️ pour signaler une publication inappropriée à l'équipe Harmonia."
          },
          "step12": {
            "title": "Modifier ou supprimer ses posts",
            "desc": "Sur vos propres publications, une icône ✏️ permet de modifier le texte et une icône 🗑️ permet de supprimer. Ces boutons n'apparaissent que sur vos propres publications."
          },
          "step13": {
            "title": "Voir une image en grand",
            "desc": "Appuyez sur une image dans le fil pour l'ouvrir. Double-tap pour l'afficher en plein écran. Re-tap pour fermer."
          },
          "step14": {
            "title": "Lire une vidéo ou un audio",
            "desc": "Les publications vidéo affichent un bouton ▶️. Les soumissions musicales disposent d'un lecteur intégré avec Play/Pause et barre de progression. Appuyez sur ❤️ pour voter."
          },
          "step15": {
            "title": "Voter sur les créations du fil",
            "desc": "Les soumissions artistiques et de performance apparaissent dans le fil. Faites défiler verticalement pour parcourir les vidéos style TikTok. Appuyez sur ❤️ pour voter pour votre favori."
          },
          "step16": {
            "title": "Rechercher dans le fil",
            "desc": "Appuyez sur l'icône 🔍 dans le header pour ouvrir la barre de recherche et trouver des publications ou des utilisateurs."
          },
          "step17": {
            "title": "Notifications",
            "desc": "Appuyez sur l'icône 🔔 dans le header pour consulter vos notifications (likes, commentaires, demandes d'amis, etc.)."
          }
        }
      },
      "jeux": {
        "title": "Centre des Talents",
        "steps": {
          "step1": {
            "title": "Explorer les disciplines",
            "desc": "L'onglet Jeux 🎮 ouvre le Centre des Talents avec 6 catégories : Jeux Stratégiques · Connaissances · Arts · Performance · Musique · Artisanat. Faites défiler pour tout voir."
          },
          "step2": {
            "title": "Découvrir un jeu en détail",
            "desc": "Faites un appui long (≈ 0,4 s) sur n'importe quel jeu pour ouvrir sa fiche : description, tagline et badge trophée. Appuyez sur « Commencer l'aventure » ou fermez la fiche."
          },
          "step3": {
            "title": "Ouvrir un jeu",
            "desc": "Appuyez normalement sur un jeu pour l'ouvrir en plein écran. Le bouton ⓘ dans le header affiche le bandeau de présentation d'Harmonia."
          },
          "step4": {
            "title": "Rejoindre une session",
            "desc": "Dans chaque jeu, l'onglet « Explorer » liste les sessions disponibles (gratuites ou payantes en CFA). Appuyez sur « Participer » pour rejoindre. L'onglet « Mes Sessions » affiche celles déjà rejointes."
          },
          "step5": {
            "title": "Vrai ou Faux — Répondre à une question",
            "desc": "Onglet Sessions → choisissez une session → un groupe. Appuyez sur « Répondre ». La question s'affiche avec une barre de progression. Appuyez sur « VRAI » (vert) ou « FAUX » (rouge). Naviguez entre les questions avec Précédente / Suivante."
          },
          "step6": {
            "title": "Vrai ou Faux — Groupes verrouillés",
            "desc": "Certains groupes nécessitent un score minimum pour y accéder. Si votre score est insuffisant, le groupe affiche une icône 🔒 et le score requis."
          },
          "step7": {
            "title": "Vrai ou Faux — Voir ses réponses",
            "desc": "L'onglet « Réponses » vous permet de consulter les questions auxquelles vous avez répondu et votre choix VRAI/FAUX, sans voir les scores."
          },
          "step8": {
            "title": "Vrai ou Faux — Résultats",
            "desc": "L'onglet « Résultats » affiche vos scores et les bonnes réponses. Ces informations n'apparaissent que lorsque l'administrateur les révèle. Avant cela, un message « En attente » s'affiche."
          },
          "step9": {
            "title": "Awalé & Dames — Rejoindre et jouer",
            "desc": "Choisissez une session dans « Mes Sessions ». Quand le run est lancé, appuyez sur « Jouer maintenant ». Un compte à rebours de préparation précède chaque partie. Vous êtes toujours affiché en bas du plateau."
          },
          "step10": {
            "title": "Dames — Jouer sur le plateau",
            "desc": "Appuyez sur une de vos pièces pour la sélectionner — les cases valides s'illuminent en vert (déplacement) ou orange (capture possible). Appuyez sur la case de destination pour jouer. Les dames ♔ peuvent se déplacer dans toutes les directions."
          },
          "step11": {
            "title": "Awalé — Jouer sur le plateau",
            "desc": "Vos trous (rangée du bas) s'illuminent en vert quand c'est votre tour. Appuyez sur un trou contenant des graines pour jouer. Le score s'affiche en haut. En cas d'égalité, une manche décisive « Premier à 12 » se lance automatiquement."
          },
          "step12": {
            "title": "Classement des matchs (Awalé & Dames)",
            "desc": "L'onglet « Classement » liste vos sessions. Appuyez sur une session pour voir les runs et les résultats de chaque match (en cours 🔵 ou terminé ✅) avec le gagnant mis en valeur 🏆."
          },
          "step13": {
            "title": "Soumettre une création — Arts",
            "desc": "Onglet « Soumettre » → choisissez un run ouvert. Remplissez chaque slot avec une image (JPG · PNG · WEBP). Ajoutez une description si vous le souhaitez. Le bouton d'envoi devient actif quand tous les slots sont remplis."
          },
          "step14": {
            "title": "Soumettre — Performance & Artisanat",
            "desc": "Même principe que les Arts mais avec des vidéos (MP4 · MOV · WEBM). Tous les slots doivent être remplis. Les créations déjà soumises sont verrouillées et affichent l'icône 🔒."
          },
          "step15": {
            "title": "Soumettre — Musique",
            "desc": "Sélectionnez vos fichiers audio (MP3 · WAV · M4A) depuis votre galerie. Remplissez tous les slots requis, ajoutez une description facultative, puis envoyez."
          },
          "step16": {
            "title": "Classement créatif & Votes",
            "desc": "L'onglet « Classement » affiche le podium 🥇🥈🥉 avec le nombre de votes ❤️ de chaque participant. Il s'actualise dès que les votes sont ouverts par l'administrateur."
          }
        }
      },
      "messages": {
        "title": "Messages",
        "steps": {
          "step1": {
            "title": "Historique des conversations",
            "desc": "L'onglet Historique 🕐 liste vos conversations privées et de groupe. Un badge rouge indique les messages non lus. L'aperçu du dernier message affiche un emoji selon son type : 📷 Photo · 🎬 Vidéo · 🎵 Audio · 📁 Fichier."
          },
          "step2": {
            "title": "Amis en ligne",
            "desc": "L'onglet « En ligne » 🟢 affiche vos amis actuellement connectés (point vert). Appuyez sur un ami pour démarrer une conversation directement."
          },
          "step3": {
            "title": "Mes amis",
            "desc": "L'onglet « Amis » 👥 liste tous vos amis (en ligne ou hors ligne). Appuyez sur un nom pour ouvrir la conversation."
          },
          "step4": {
            "title": "Groupes",
            "desc": "L'onglet « Groupes » affiche vos conversations de groupe. Appuyez sur un groupe pour l'ouvrir."
          },
          "step5": {
            "title": "Rechercher une conversation",
            "desc": "Appuyez sur l'icône 🔍 dans le header pour afficher la barre de recherche. Elle fonctionne dans chaque onglet — Historique, En ligne, Amis et Groupes."
          },
          "step6": {
            "title": "Synchronisation manuelle",
            "desc": "Appuyez sur l'icône de synchronisation, directement visible dans le header « Messages », pour lancer une synchronisation. Une animation en 3 étapes s'affiche : Initialisation → Actualisation → Synchronisation des données. Un retour visuel confirme la réussite ou signale une erreur."
          },
          "step7": {
            "title": "Envoyer un message texte",
            "desc": "Tapez dans la zone de texte (max 1 000 caractères) et appuyez sur ➤ pour envoyer. Le statut s'affiche sous votre bulle : ⏳ envoi en cours · ✓ envoyé · ✓✓ lu."
          },
          "step8": {
            "title": "Renvoyer un message échoué",
            "desc": "Si un message n'a pas pu être envoyé après 3 tentatives, sa bulle apparaît avec une bordure rouge et un bouton « Réessayer » 🔁. Appuyez dessus pour renvoyer."
          },
          "step9": {
            "title": "Envoyer des médias (PRO)",
            "desc": "Les membres PRO voient un bouton 📎 à gauche de la zone de texte. Appuyez pour joindre une image, une vidéo ou un document (PDF, Word, Excel, etc.) à votre message."
          },
          "step10": {
            "title": "Enregistrer et envoyer une note vocale (PRO)",
            "desc": "Quand la zone de texte est vide, les membres PRO voient un bouton 🎤. Maintenez pour enregistrer. Appuyez sur ⏹ pour arrêter. Un lecteur de prévisualisation apparaît avec Play/Pause, barre de progression et durée totale. Appuyez sur ➤ pour envoyer ou 🗑️ pour annuler."
          },
          "step11": {
            "title": "Répondre dans un groupe",
            "desc": "Faites un appui long sur un message pour ouvrir les actions. Choisissez « Répondre en public » 🌍 (tout le groupe voit la réponse) ou « Répondre en privé » 🔒 (visible uniquement par vous et le destinataire)."
          },
          "step12": {
            "title": "Changer la visibilité de sa réponse",
            "desc": "Double-tap sur votre propre réponse dans un groupe pour basculer entre public et privé. L'icône 👁 ou 🚫👁 confirme l'état actuel. Vous pouvez aussi utiliser l'appui long → « Rendre privé » / « Rendre visible »."
          },
          "step13": {
            "title": "Supprimer un message",
            "desc": "Faites un appui long sur l'un de vos messages, puis appuyez sur « Supprimer ». Le message est remplacé par « Message supprimé » pour tous les participants."
          },
          "step14": {
            "title": "Voir une image en plein écran",
            "desc": "Double-tap sur une image dans une conversation pour l'afficher en plein écran. Re-tap ou croix ✕ pour fermer."
          },
          "step15": {
            "title": "Bannière hors-ligne",
            "desc": "Si la connexion est perdue, une bannière rouge apparaît en haut de la conversation. Vos messages sont mis en attente et renvoyés automatiquement dès que la connexion revient."
          }
        }
      },
      "amis": {
        "title": "Réseau & Amis",
        "steps": {
          "step1": {
            "title": "Suggestions d'amis",
            "desc": "L'onglet Réseau 👥 affiche des personnes que vous pourriez connaître. Faites défiler pour charger plus de suggestions. Appuyez sur le bouton ➕ à droite d'un nom pour lui envoyer une demande d'ami."
          },
          "step2": {
            "title": "Rechercher un utilisateur",
            "desc": "Appuyez sur l'onglet « Recherche » 🔍. Tapez un nom ou un prénom dans la barre, puis appuyez sur la flèche → pour lancer la recherche. Appuyez sur ➕ pour envoyer une demande à un résultat."
          },
          "step3": {
            "title": "Demandes reçues",
            "desc": "L'onglet « Demandes » 📩 affiche un badge rouge si vous avez des demandes en attente. Sous-onglet « Reçues » : appuyez sur « Accepter » pour devenir amis, ou « Refuser » pour décliner."
          },
          "step4": {
            "title": "Demandes envoyées",
            "desc": "Sous-onglet « Envoyées » : retrouvez toutes vos demandes en attente de réponse. Appuyez sur « Annuler » pour retirer une demande."
          },
          "step5": {
            "title": "Voir le profil d'un utilisateur",
            "desc": "Dans les suggestions, les résultats de recherche ou les demandes, appuyez sur le nom ou l'avatar d'un utilisateur pour ouvrir sa fiche profil."
          }
        }
      },
      "profil": {
        "title": "Mon Profil",
        "steps": {
          "step1": {
            "title": "Modifier la photo de profil",
            "desc": "Sur l'écran Profil, appuyez sur l'icône 📷 orange sur votre avatar pour choisir une nouvelle photo depuis votre galerie. La mise à jour est immédiate."
          },
          "step2": {
            "title": "Solde CFA et Trophées",
            "desc": "Deux cartes colorées affichent votre solde CFA 💰 et votre nombre de trophées 🏆 remportés. Ces compteurs se mettent à jour automatiquement."
          },
          "step3": {
            "title": "Recharger le solde",
            "desc": "Appuyez sur la carte « Recharger mon solde » (portefeuille doré) pour accéder à l'écran de recharge. Vous pouvez aussi recharger depuis le fil d'actualité en appuyant sur votre solde CFA."
          },
          "step4": {
            "title": "Modifier ses informations",
            "desc": "Appuyez sur « Paramètres » ⚙️ dans la section « Mon compte ». Un panneau s'ouvre depuis le bas avec les champs Nom, Prénom et Date de naissance. Modifiez puis appuyez sur « Enregistrer »."
          },
          "step5": {
            "title": "Confidentialité",
            "desc": "Appuyez sur « Confidentialité » 🛡️ pour accéder aux paramètres de vie privée, de données et de sécurité de votre compte."
          },
          "step6": {
            "title": "Accéder au guide",
            "desc": "Appuyez sur « Guide d'utilisation » 📖 dans la section « Mon compte » pour ouvrir ce guide à tout moment."
          },
          "step7": {
            "title": "Créer une publication depuis le profil",
            "desc": "Dans la section « Publications », appuyez sur le bouton « Publier » (dégradé rose-orange). Le formulaire de création s'ouvre avec les mêmes options que dans le fil."
          },
          "step8": {
            "title": "Gérer ses publications",
            "desc": "Vos publications sont listées en bas du profil. Sur chacune : ✏️ pour modifier le texte · 🗑️ pour supprimer (une confirmation est demandée). Les actions liker, commenter, partager et sauvegarder sont aussi disponibles."
          },
          "step9": {
            "title": "Ajouter des médias à une publication (PRO)",
            "desc": "Les membres PRO voient des boutons 📷 Photo et 🎬 Vidéo dans le formulaire de création. Un aperçu s'affiche avant publication. Appuyez sur ✖ pour retirer le média."
          },
          "step10": {
            "title": "Se déconnecter",
            "desc": "Appuyez sur l'icône de déconnexion 🚪 en haut à droite du profil. Une confirmation vous est demandée avant la déconnexion effective. Si vous aviez choisi de rester connecté, cette déconnexion est définitive : vous retrouverez l'écran de connexion à la prochaine ouverture de l'application."
          }
        }
      },
      "pro": {
        "title": "Statut PRO ⭐",
        "steps": {
          "step1": {
            "title": "Badge PRO visible",
            "desc": "Le badge ⭐ PRO apparaît sur votre profil et est visible de tous les membres de la communauté Harmonia."
          },
          "step2": {
            "title": "Publications enrichies",
            "desc": "Les membres PRO peuvent joindre une photo ou une vidéo à leurs publications dans le fil d'actualité. Les publications avec visibilité « PRO » ne sont visibles que par les autres membres PRO."
          },
          "step3": {
            "title": "Médias dans les messages",
            "desc": "En tant que membre PRO, vous pouvez envoyer des images, des vidéos et des documents (PDF, Word, Excel, etc.) dans les conversations privées et de groupe."
          },
          "step4": {
            "title": "Notes vocales",
            "desc": "Les membres PRO peuvent enregistrer et envoyer des notes vocales dans les messages. Un lecteur de prévisualisation intégré permet d'écouter l'enregistrement avant de l'envoyer."
          },
          "step5": {
            "title": "Passer au statut PRO",
            "desc": "Appuyez sur « Recharger mon solde » dans votre profil ou sur votre solde CFA dans le fil. Rechargez votre compte via Mobile Money pour accéder aux fonctionnalités PRO."
          }
        }
      },
      "market": {
        "title": "Boutique Pro & Market ⭐",
        "steps": {
          "step1": {
            "title": "Ouvrir le Market",
            "desc": "Un 6ème bouton « Market » 🛍️ est disponible dans la barre de navigation principale. Appuyez dessus : la barre défile et laisse place à une nouvelle barre de navigation dédiée au Market, avec 4 boutons : Home, Tous les produits, Boutiques et Réglages."
          },
          "step2": {
            "title": "Revenir à la navigation principale",
            "desc": "Depuis le Market, appuyez sur le bouton « Home » 🏠 pour revenir à la barre de navigation principale de l'application."
          },
          "step3": {
            "title": "Parcourir tous les produits",
            "desc": "Le bouton « Tous les produits » affiche l'ensemble des produits publiés par les boutiques de la plateforme, tous vendeurs confondus."
          },
          "step4": {
            "title": "Parcourir les boutiques",
            "desc": "Le bouton « Boutiques » affiche la liste des boutiques créées par les membres PRO sur Harmonia."
          },
          "step5": {
            "title": "Créer sa boutique et son site web (PRO)",
            "desc": "En tant que membre PRO, le bouton « Réglages » ⚙️ du Market vous permet de créer votre propre boutique. Harmonia génère alors un véritable site web pour votre boutique, accessible via un lien URL public fonctionnel sur le web, en plus d'être visible directement sur la plateforme."
          },
          "step6": {
            "title": "Personnaliser le site de sa boutique (PRO)",
            "desc": "Depuis « Réglages », personnalisez le design et de nombreux paramètres du site de votre boutique : présentation, mise en page et autres éléments visuels, pour qu'il vous ressemble."
          },
          "step7": {
            "title": "Publier des produits (PRO)",
            "desc": "Toujours depuis « Réglages », ajoutez et mettez à jour les produits de votre boutique. Chaque produit publié dispose automatiquement de son propre lien web, permettant de le consulter et de le partager directement."
          },
          "step8": {
            "title": "Gérer les boutiques suivies",
            "desc": "Dans « Réglages », retrouvez la liste des boutiques auxquelles vous êtes abonné. Vous pouvez vous désabonner d'une boutique à tout moment depuis cet écran."
          },
          "step9": {
            "title": "Retrouver ses produits enregistrés",
            "desc": "Toujours dans « Réglages », consultez la liste des produits que vous avez enregistrés lors de votre navigation dans le Market."
          }
        }
      }
    }
  },
  "politiqueCookies": {
    "title": "Politique de Cookies",
    "stats": {
      "sections": "Sections",
      "zeroTracking": "Zéro tracking",
      "essentialOnly": "Cookies essentiels seul"
    },
    "sections": {
      "definition": {
        "title": "Qu'est-ce qu'un cookie ?",
        "p1": "Un cookie est un petit fichier texte déposé sur votre appareil (ordinateur, tablette, smartphone) lors de votre navigation. Il permet à la plateforme de mémoriser certaines informations pour améliorer votre expérience.",
        "highlight1": "Les cookies ne peuvent pas endommager votre appareil et ne contiennent aucun virus."
      },
      "politique": {
        "title": "Harmonia et les cookies",
        "p1": "Harmonia adopte une politique stricte et minimaliste en matière de cookies.",
        "highlight1": "Nous n'utilisons aucun cookie à des fins publicitaires externes, de profilage ou de suivi tiers.",
        "p2": "Aucun outil d'analyse externe (tel que Google Analytics) n'est utilisé. Vos données de navigation ne sont jamais transmises à des partenaires publicitaires extérieurs."
      },
      "utilises": {
        "title": "Cookies que nous utilisons",
        "p1": "Harmonia utilise uniquement des cookies techniques strictement nécessaires au bon fonctionnement de la plateforme.",
        "sub1": "Cookies de session et d'authentification",
        "p2": "Permettent de vous maintenir connecté à votre compte Harmonia. Créés à l'ouverture de votre session, ils sont par défaut supprimés à sa fermeture.",
        "highlight1": "Vous pouvez choisir de rester connecté : dans ce cas, un jeton d'authentification persistant est conservé pour éviter de ressaisir votre mot de passe. Ce choix vous appartient et reste modifiable à tout moment.",
        "sub2": "Cookies liés aux fournisseurs tiers (Google, etc.)",
        "p3": "Lorsque vous vous connectez via Google ou un autre fournisseur, ce dernier peut déposer ses propres cookies dans le cadre du processus d'authentification. Ceux-ci sont régis par leur propre politique de confidentialité.",
        "sub3": "Cookies de sécurité",
        "p4": "Contribuent à la protection de votre compte contre les tentatives de fraude et d'accès non autorisé.",
        "sub4": "Cookies liés aux paiements",
        "p5": "Lors d'une transaction (abonnement, concours payant, boutique pro), les prestataires de paiement peuvent déposer des cookies techniques limités à la durée de la transaction pour en assurer la sécurité."
      },
      "nonUtilises": {
        "title": "Cookies NON utilisés",
        "p1": "Par transparence totale, voici ce que Harmonia n'utilise pas :",
        "bullets1": [
          "Cookies publicitaires — aucune publicité externe, aucun ciblage",
          "Cookies de tracking analytique tiers — aucun outil externe d'analyse",
          "Cookies de profilage comportemental — aucun profil publicitaire construit"
        ]
      },
      "mobile": {
        "title": "Application mobile",
        "p1": "Sur l'application mobile Harmonia, les cookies au sens strict ne sont pas utilisés. Des technologies similaires (tokens d'authentification sécurisés, stockage local) sont employées pour assurer le bon fonctionnement.",
        "highlight1": "Si vous choisissez de rester connecté, un jeton d'authentification est conservé localement sur votre appareil. Vous restez propriétaire de ce choix et pouvez vous déconnecter à tout moment pour le supprimer.",
        "p2": "Ces données sont stockées uniquement sur votre appareil et ne sont jamais partagées avec des tiers à des fins publicitaires."
      },
      "duree": {
        "title": "Durée de conservation",
        "bullets1": [
          "Cookie de session — supprimé à la fermeture de la session",
          "Cookie d'authentification — durée de votre session active, ou jusqu'à déconnexion explicite si « rester connecté » est activé",
          "Cookie de sécurité — durée de votre session active",
          "Cookie de paiement — durée de la transaction uniquement"
        ]
      },
      "gestion": {
        "title": "Gestion de vos cookies",
        "sub1": "Via votre navigateur",
        "bullets1": [
          "Google Chrome : Paramètres › Confidentialité et sécurité › Cookies",
          "Mozilla Firefox : Paramètres › Vie privée et sécurité › Cookies",
          "Safari : Préférences › Confidentialité › Cookies",
          "Microsoft Edge : Paramètres › Confidentialité › Cookies"
        ],
        "highlight1": "Attention : désactiver les cookies techniques essentiels peut empêcher votre connexion à Harmonia.",
        "sub2": "Via votre appareil mobile",
        "p1": "Gérez les autorisations de l'application Harmonia directement depuis les paramètres de votre appareil iOS ou Android.",
        "sub3": "Option « rester connecté »",
        "p2": "Sur le web comme sur mobile, cette option est facultative et reste sous votre contrôle exclusif. Une déconnexion manuelle supprime le cookie ou le jeton associé."
      },
      "modifications": {
        "title": "Modifications de la politique",
        "p1": "Harmonia se réserve le droit de modifier la présente politique à tout moment, notamment en cas d'évolution technique ou de changement réglementaire. Les utilisateurs seront informés de toute modification via la plateforme.",
        "highlight1": "La poursuite de l'utilisation après modification vaut acceptation des nouvelles conditions."
      },
      "contact": {
        "title": "Contact",
        "p1": "Consultez notre guide d'utilisation disponible directement sur Harmonia pour toute question complémentaire."
      }
    }
  },
  "reglesCommunautaires": {
    "title": "Règles Communautaires",
    "stats": {
      "sections": "Sections",
      "forEveryone": "Pour tous",
      "healthyCommunity": "Communauté saine"
    },
    "sections": {
      "respect": {
        "title": "Respect et bienveillance",
        "p1": "Harmonia est un espace de partage et d'expression. Chaque membre doit traiter les autres avec respect, indépendamment de leur origine, culture, religion, genre, âge ou opinions.",
        "sub1": "Il est interdit de :",
        "bullets1": [
          "Insulter, humilier ou dégrader un autre membre",
          "Harceler, menacer ou intimider une personne ou un groupe",
          "Tenir des propos discriminatoires ou méprisants envers une communauté",
          "Encourager ou glorifier la violence sous quelque forme que ce soit"
        ]
      },
      "contenuInterdit": {
        "title": "Contenu interdit",
        "p1": "Les contenus suivants sont strictement interdits sur Harmonia, quelle que soit leur forme et leur niveau de visibilité :",
        "sub1": "Contenu sexuel et nudité",
        "p2": "Toute publication à caractère sexuel explicite ou comportant de la nudité est interdite.",
        "sub2": "Haine et discrimination",
        "p3": "Tout contenu incitant à la haine envers une personne ou un groupe en raison de leur race, ethnie, religion, nationalité, genre, orientation sexuelle ou handicap.",
        "sub3": "Violence et contenu choquant",
        "p4": "Contenus représentant des actes de violence réels, scènes de torture, mutilation ou tout contenu susceptible de traumatiser les membres.",
        "sub4": "Désinformation",
        "p5": "La publication délibérée de fausses informations dans le but de tromper, manipuler ou nuire est interdite.",
        "sub5": "Atteinte à la vie privée & Usurpation",
        "bullets1": [
          "Publier des informations personnelles d'un tiers sans son consentement",
          "Se faire passer pour une autre personne, marque ou entité officielle"
        ]
      },
      "publications": {
        "title": "Règles de publication",
        "sub1": "Limite quotidienne",
        "bullets1": [
          "Utilisateurs standards : 1 publication par jour",
          "Utilisateurs PRO : 3 publications par jour"
        ],
        "highlight1": "Cette limite renforce la qualité des informations partagées et encourage la qualité plutôt que la quantité.",
        "sub2": "Authenticité du contenu",
        "p1": "Vous vous engagez à publier uniquement du contenu dont vous êtes l'auteur ou pour lequel vous détenez les droits nécessaires.",
        "sub3": "Responsabilité selon la visibilité",
        "p2": "Vous êtes seul responsable de votre contenu, quel que soit le niveau de visibilité choisi. La visibilité PRO, accessible à toute la communauté et incluse dans la limite de 3 publications quotidiennes qui lui est propre, implique une responsabilité accrue."
      },
      "messagerie": {
        "title": "Messagerie et groupes",
        "p1": "Les règles de respect et de bienveillance s'appliquent également dans la messagerie privée et les groupes de discussion. Le caractère privé d'un échange ne justifie en aucun cas un comportement irrespectueux.",
        "highlight1": "L'envoi de messages non sollicités à caractère commercial, publicitaire ou harcelant est interdit."
      },
      "concours": {
        "title": "Concours et compétitions",
        "sub1": "Authenticité des participations",
        "p1": "Chaque participant doit soumettre uniquement des créations originales dont il est l'auteur. Toute fraude ou plagiat entraîne la disqualification immédiate et définitive.",
        "sub2": "Intégrité du vote",
        "bullets1": [
          "Voter en échange de contreparties (argent, services) est interdit",
          "Utiliser des outils automatisés pour manipuler les votes est interdit",
          "Voter plusieurs fois via plusieurs comptes est interdit"
        ],
        "highlight1": "Chaque utilisateur authentifié dispose d'un seul vote par candidat. Tout contournement entraîne la suspension des votes concernés.",
        "sub3": "Respect entre concurrents",
        "p2": "Tout dénigrement, moquerie ou attaque envers un autre participant est interdit. La compétition doit rester saine et respectueuse.",
        "sub4": "Jeux de stratégie et culture générale",
        "p3": "Les jeux (dames, Awalé, Vrai ou Faux…) doivent être pratiqués avec fair-play. L'utilisation de logiciels d'assistance ou tout moyen déloyal est interdit.",
        "sub5": "Information en temps réel",
        "p4": "Harmonia diffuse en temps réel des informations sur le déroulement des concours et l'activité de la plateforme, afin que tous les utilisateurs soient informés équitablement et au même moment. Toute tentative de manipulation ou de détournement de cette diffusion est interdite."
      },
      "publicite": {
        "title": "Publicité et contenu commercial",
        "p1": "Seuls les utilisateurs ayant souscrit à un abonnement publicitaire Harmonia sont autorisés à publier du contenu publicitaire sur la plateforme.",
        "highlight1": "Tout démarchage commercial non autorisé, promotion d'activités illégales ou diffusion de liens frauduleux est strictement interdit."
      },
      "boutiques": {
        "title": "Boutiques pro",
        "p1": "Les utilisateurs PRO peuvent créer une boutique sur la plateforme, accessible via Harmonia et via un lien URL public sur le web. Chaque produit publié dispose de son propre lien web.",
        "highlight1": "Les règles relatives au contenu interdit et à la publicité s'appliquent intégralement au contenu d'une boutique pro et de ses produits, y compris lorsqu'ils sont consultés via un lien web public.",
        "sub1": "Interdictions spécifiques",
        "bullets1": [
          "Vendre ou proposer des produits ou services illégaux",
          "Publier des informations trompeuses sur les produits proposés",
          "Utiliser la boutique à des fins d'escroquerie ou de collecte abusive de données envers les visiteurs"
        ],
        "p2": "L'utilisateur PRO est seul responsable du contenu de sa boutique. Toute boutique ou produit non conforme peut être suspendu, y compris via la désactivation du lien web associé."
      },
      "signalement": {
        "title": "Signalement",
        "sub1": "Comment signaler",
        "p1": "Si vous constatez un contenu enfreignant les règles, signalez-le via la fonctionnalité prévue à cet effet sur la plateforme.",
        "sub2": "Traitement des signalements",
        "bullets1": [
          "Seuil de signalements atteint → contenu en état d'examen (non visible)",
          "Contenu conforme → retrouve sa visibilité normale",
          "Contenu non conforme → suspendu définitivement"
        ],
        "highlight1": "Tout usage abusif de la fonctionnalité de signalement est lui-même contraire aux règles communautaires."
      },
      "sanctions": {
        "title": "Conséquences des violations",
        "sub1": "Suspension de contenu",
        "p1": "Tout contenu jugé contraire aux règles est suspendu définitivement et sans appel. Harmonia ne procède pas au bannissement des utilisateurs ; les mesures portent sur les contenus, non sur les personnes.",
        "sub2": "Absence de remboursement",
        "p2": "La suspension d'un contenu payant (visibilité PRO ou boutique pro) ne donne lieu à aucun remboursement.",
        "sub3": "Responsabilité personnelle",
        "highlight1": "En cas d'infraction grave aux lois en vigueur, Harmonia se réserve le droit de transmettre les éléments nécessaires aux autorités compétentes si la loi l'exige."
      },
      "api": {
        "title": "Interdiction d'accès à l'API",
        "p1": "L'API backend et les systèmes techniques de Harmonia sont réservés à un usage exclusivement interne à la plateforme. Il est strictement interdit de :",
        "bullets1": [
          "Accéder à l'API en dehors des applications officielles",
          "Utiliser des scripts, robots ou outils automatisés pour extraire des données",
          "Contourner les systèmes de sécurité ou d'authentification",
          "Intercepter les communications entre les applications et les serveurs",
          "Exploiter ou tenter d'exploiter toute faille technique"
        ],
        "highlight1": "Ces actes constituent des infractions graves passibles de poursuites judiciaires. Harmonia coopère avec les autorités compétentes pour identifier et poursuivre les contrevenants.",
        "p2": "Toute faille découverte doit être signalée à harmonia@harmoniaworld.world sans être exploitée."
      },
      "evolution": {
        "title": "Évolution des règles",
        "p1": "Harmonia se réserve le droit de faire évoluer ces règles à tout moment, en fonction du développement de la plateforme et des besoins de la communauté.",
        "highlight1": "La poursuite de l'utilisation après modification vaut acceptation des nouvelles règles."
      },
      "contact": {
        "title": "Contact",
        "p1": "Consultez notre guide d'utilisation disponible directement sur Harmonia pour toute question."
      }
    }
  },
  "actuScreen": {
    "toasts": {
      "noConnection": "Pas de connexion internet",
      "mediaAccessRequired": "Accès aux médias requis.",
      "imageAdded": "Image ajoutée !",
      "videoAdded": "Vidéo ajoutée !",
      "cannotAddMedia": "Impossible d'ajouter le média",
      "contentRequired": "Le contenu est obligatoire",
      "limitReached": "Limite de publications atteinte.",
      "postPublished": "Post publié !",
      "cannotPublish": "Impossible de publier",
      "reportRegistered": "Signalement pris en compte !",
      "reportError": "Erreur lors du signalement",
      "networkError": "Erreur réseau",
      "postSanctioned": "Publication sanctionnée ({{status}})",
      "adminError": "Erreur d'administration"
    },
    "offlineBanner": "Pas de connexion — Hors ligne",
    "doubleTapToShow": "Double-tap pour afficher",
    "loading": "Chargement...",
    "upToDate": "Vous êtes à jour ✓",
    "report": {
      "title": "Signaler",
      "message": "Signaler cette publication ?",
      "confirm": "Oui, signaler",
      "cancel": "Annuler"
    },
    "filters": {
      "all": "Tout",
      "posts": "Publications",
      "images": "Images",
      "videos": "Vidéos",
      "music": "Musique"
    },
    "filterMenu": {
      "title": "Afficher"
    },
    "adminStrike": {
      "title": "Frappe Directe",
      "selectSanction": "Sélectionnez la sanction :",
      "pending": "Mettre en attente (Pending)",
      "lock": "Verrouiller (Active)",
      "cancel": "Annuler"
    },
    "empty": {
      "offlineTitle": "Aucun contenu Hors-ligne",
      "emptyFeedTitle": "Votre fil d'actualité est vide",
      "offlineSubtitle": "Reconnectez-vous pour charger votre fil d'actualité.",
      "emptyFeedSubtitle": "Ajoutez des amis pour découvrir leurs publications, leurs créations et leurs performances.\n\nPlus vous avez d'amis actifs, plus votre fil sera animé ! 🎨"
    },
    "createPost": {
      "title": "Nouvelle publication",
      "placeholder": "Quoi de neuf ?",
      "videoReady": "Vidéo prête",
      "photo": "Photo",
      "video": "Vidéo",
      "publish": "Publier"
    },
    "visibility": {
      "public": "Public",
      "friends": "Amis",
      "pro": "PRO",
      "private": "Privé"
    },
    "postDetails": {
      "title": "📊 Détails",
      "author": "Auteur :",
      "published": "Publié :",
      "reactions": "Réactions :",
      "close": "Fermer"
    }
  },
  "tabsLayout": {
    "offlineText": "Pas de connexion internet",
    "tabs": {
      "actu": "Actu",
      "games": "Jeux",
      "market": "Market",
      "messages": "Messages",
      "friends": "Amis",
      "profile": "Profil"
    }
  },
  "gamesScreen": {
    "header": {
      "pill": "Centre des Talents",
      "title": "Révélez votre Talent"
    },
    "infoBanner": {
      "title": "🏆 Harmonia — Centre des Talents",
      "text": "Bienvenue sur Harmonia, la plateforme qui révèle et célèbre les talents de notre communauté. Participez aux défis, affrontez vos amis, montrez ce que vous savez faire — et remportez des trophées décernés publiquement devant toute la communauté. Chaque semaine, de nouveaux défis, de nouvelles disciplines, de nouvelles occasions de briller. Votre talent mérite d'être vu. Votre victoire mérite d'être célébrée. Rejoignez le mouvement. Révélez votre talent. Harmonia vous attend. 🎯"
    },
    "chooseDiscipline": "CHOISISSEZ VOTRE DISCIPLINE",
    "longPressHint": "Appui long sur un jeu pour plus de détails",
    "footerNote": "Nouveau contenu ajouté chaque semaine — restez connecté !",
    "trophiesAwardedPublicly": "Trophées remis publiquement devant la communauté",
    "startAdventure": "Commencer l'aventure",
    "categories": {
      "strategie": {
        "title": "Jeux Stratégiques",
        "description": "Réflexion & tactique",
        "items": {
          "s1": {
            "title": "Awalé",
            "tagline": "L'art ancestral de la stratégie",
            "detail": "Maîtrisez l'art ancestral de l'Awalé et défiez vos amis dans des parties stratégiques d'une intensité rare. Chaque graine semée, chaque capture décisive vous rapproche du sommet du classement. Les plus grands tacticiens d'Harmonia verront leur trophée remis publiquement devant toute la communauté — parce que la victoire mérite d'être consacrée à ciel ouvert."
          },
          "s2": {
            "title": "Dames",
            "tagline": "Dominez l'échiquier, régnez sur la scène",
            "detail": "Affrontez vos adversaires dans des duels de stratégie pure sur le damier. Anticipez chaque mouvement, dominez chaque échange et éliminez pour gravir les échelons du classement Harmonia. Les champions sont couronnés publiquement — leur trophée, remis devant l'ensemble de la communauté, témoigne d'une excellence qui force l'admiration."
          }
        }
      },
      "connaissance": {
        "title": "Jeux de Connaissances",
        "description": "Testez votre savoir",
        "items": {
          "c1": {
            "title": "Vrai ou Faux",
            "tagline": "Défiez vos amis à coups de vérités",
            "detail": "Testez l'étendue de votre savoir et défiez vos amis dans des duels intellectuels aussi palpitants qu'imprévisibles. Répondez Vrai ou Faux avec précision et conviction, progressez de niveau en niveau et gravissez le classement Harmonia. Vos trophées seront remis en public, devant toute la communauté — parce que la connaissance, lorsqu'elle est au sommet, mérite sa couronne."
          }
        }
      },
      "arts": {
        "title": "Arts",
        "description": "Créativité & expression",
        "items": {
          "a1": {
            "title": "Photo",
            "tagline": "Votre regard, votre signature",
            "detail": "La photographie est un regard sur le monde que vous seul possédez. Soumettez vos clichés les plus saisissants, faites-vous remarquer par la communauté Harmonia et recevez des trophées décernés publiquement en hommage à votre œil artistique exceptionnel. Sur Harmonia, votre vision mérite d'être exposée, admirée et célébrée à sa juste valeur."
          },
          "a2": {
            "title": "Dessin",
            "tagline": "Votre trait, votre univers",
            "detail": "Votre trait est votre signature, votre style est votre identité. Partagez vos créations dessinées avec la communauté Harmonia, faites vibrer les esprits et soyez récompensé de trophées remis publiquement en reconnaissance de votre génie créatif. L'art ne vit que par ceux qui ont le courage de le montrer — et Harmonia est votre scène."
          },
          "a3": {
            "title": "Design",
            "tagline": "L'esthétique au service de l'intention",
            "detail": "Le design est la rencontre entre l'esthétique et l'intention, entre la forme et le sens. Exposez vos créations visuelles les plus audacieuses sur Harmonia, inspirez votre communauté et décrochez des trophées décernés en public. Un grand designer mérite une grande reconnaissance — et Harmonia vous offre la tribune qu'il vous faut."
          }
        }
      },
      "performance": {
        "title": "Performance",
        "description": "Montez sur scène",
        "items": {
          "p1": {
            "title": "Comédie",
            "tagline": "Le rire, l'art le plus universel",
            "detail": "Le rire est le plus universel et le plus précieux des talents humains. Montez sur la scène d'Harmonia, faites vibrer la communauté avec votre humour, votre sens du timing et votre présence scénique incomparable. Les meilleurs comédiens verront leurs trophées remis publiquement — parce que faire rire, c'est un art qui mérite d'être honoré devant tous."
          },
          "p2": {
            "title": "Danse",
            "tagline": "Chaque mouvement raconte une histoire",
            "detail": "Chaque mouvement raconte une histoire que les mots ne peuvent exprimer. Partagez votre talent de danseur avec la communauté Harmonia — grâce, puissance, créativité, émotion — et décrochez des trophées remis en public, en hommage à votre maîtrise absolue de la scène. La danse est un langage universel : Harmonia est votre podium."
          },
          "p3": {
            "title": "Théâtre",
            "tagline": "Incarnez, captivez, transcendez",
            "detail": "L'art dramatique est l'expression la plus profonde et la plus juste de l'âme humaine. Incarnez vos personnages avec intensité, captivez votre audience et faites de chaque performance un moment inoubliable. Sur Harmonia, les grands comédiens de théâtre sont couronnés publiquement — votre talent mérite sa lumière, son ovation, sa consécration."
          }
        }
      },
      "musique": {
        "title": "Musique",
        "description": "Faites vibrer la scène",
        "items": {
          "m1": {
            "title": "Chant",
            "tagline": "Votre voix, votre instrument le plus précieux",
            "detail": "Votre voix est votre instrument le plus précieux, votre timbre est votre empreinte dans le monde. Que vous vous exprimiez en a cappella pur ou en performance accompagnée, laissez votre voix résonner dans toute la communauté Harmonia. Les trophées sont remis en public — parce que les grandes voix méritent leur ovation, leur reconnaissance et leur lumière."
          },
          "m2": {
            "title": "Piano",
            "tagline": "88 touches, un univers infini",
            "detail": "Les 88 touches du piano renferment un univers entier — de la douceur mélancolique aux tempêtes de passion. Montrez votre virtuosité, émerveillez la communauté Harmonia par la richesse de votre jeu et recevez des trophées décernés publiquement en reconnaissance de votre maîtrise et de votre sensibilité musicale exceptionnelle."
          },
          "m3": {
            "title": "Guitare",
            "tagline": "Chaque accord, une déclaration",
            "detail": "Qu'elle soit acoustique, électrique ou classique, la guitare a le pouvoir de faire vibrer les âmes et de transcender les frontières. Partagez vos performances avec la communauté Harmonia — chaque riff, chaque solo, chaque accord vous rapproche du sommet. Faites-vous couronner lors de remises de trophées publiques, devant tous."
          }
        }
      },
      "artisanat": {
        "title": "Artisanat",
        "description": "Savoir-faire & métiers d'excellence",
        "items": {
          "ar1": {
            "title": "Couture",
            "tagline": "L'art qui habille le monde",
            "detail": "La couture est un art millénaire qui habille le monde avec précision et élégance. Montrez vos créations, votre sens du détail et votre maîtrise de l'aiguille à la communauté Harmonia. Vos trophées vous seront remis publiquement — parce que l'excellence du savoir-faire mérite d'être honorée, exposée et célébrée devant tous."
          },
          "ar2": {
            "title": "Menuiserie",
            "tagline": "Le bois entre vos mains devient œuvre",
            "detail": "Le bois entre vos mains devient architecture, beauté et utilité. Partagez vos réalisations les plus remarquables avec la communauté Harmonia et recevez des trophées décernés en public, en hommage à la noblesse de votre maîtrise artisanale. La menuiserie est un art exigeant — Harmonia lui rend l'honneur qu'il mérite."
          },
          "ar3": {
            "title": "Coiffure",
            "tagline": "Sublimer, transformer, révéler",
            "detail": "La coiffure transforme, embellit et révèle ce que les personnes portent de plus beau en elles. Présentez vos créations capillaires les plus audacieuses à la communauté Harmonia et décrochez des trophées remis publiquement — parce que l'art de sublimer l'autre est un don rare qui mérite sa plus belle et plus juste reconnaissance."
          },
          "ar4": {
            "title": "Soudure",
            "tagline": "La précision qui unit les métaux",
            "detail": "La soudure fusionne les métaux, l'ingéniosité et la précision en un seul geste maîtrisé. Partagez votre expertise technique et vos réalisations les plus impressionnantes avec la communauté Harmonia. Vos trophées vous seront décernés en public — la rigueur, la précision et l'excellence artisanale méritent leur couronne et leur reconnaissance."
          },
          "ar5": {
            "title": "Mécanique",
            "tagline": "La science qui fait tourner le monde",
            "detail": "La mécanique est la science qui fait tourner le monde, littéralement. Démontrez votre expertise, partagez vos réalisations techniques les plus élaborées avec la communauté Harmonia et recevez des trophées remis publiquement en hommage à votre maîtrise exceptionnelle des machines, des moteurs et de l'ingénierie. L'excellence mécanique mérite son podium."
          }
        }
      }
    }
  }
}
